import { Trans } from "@lingui/react";
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Typography, LoadingWrapper } from '@prezi/common-components';
import { green500 } from '@prezi/common-design';
import { CollaboratorRole } from '../../../api/folder';
import { selectContacts, selectFolderCollaborators, selectFoldersRestrictions } from '../../../store';
import { actions } from '../../../store/actions/actions';
import Collaborator from './components/Collaborator';
import AddCollaborators from './components/AddCollaborators';
import ConfirmRemoveModal from './components/ConfirmRemoveModal';
import * as Organisms from '../../organisms';
import { ConfigContext } from '../../../utils/config';
import { InnerScreenGrid, RowGap } from '../../atoms/dumb';
const Header = styled.div.withConfig({
  displayName: "FolderCollaboratorsPage__Header",
  componentId: "ys0j0k-0"
})(["padding-top:30px;"]);
const CollaboratorsList = styled.div.withConfig({
  displayName: "FolderCollaboratorsPage__CollaboratorsList",
  componentId: "ys0j0k-1"
})(["overflow:scroll;height:250px;padding:0;"]);
const CollaboratorsTitle = styled.div.withConfig({
  displayName: "FolderCollaboratorsPage__CollaboratorsTitle",
  componentId: "ys0j0k-2"
})(["display:flex;align-items:baseline;"]);
const EmailSentMessage = styled.div.withConfig({
  displayName: "FolderCollaboratorsPage__EmailSentMessage",
  componentId: "ys0j0k-3"
})(["background-color:", ";color:white;border-radius:4px;padding:5px;margin-inline-start:15px;margin-bottom:5px;transition:opacity 1s ease-in-out;opacity:", ";"], green500, p => p.isShowingMessage ? '1' : '0');
export const FolderCollaboratorsPage = ({
  folder,
  user
}) => {
  var _restrictionsEntity$v, _restrictionsEntity$v2;
  const dispatch = useDispatch();
  const {
    onClose
  } = React.useContext(ConfigContext);
  const [selectedCollaboratorId, setCollaboratorId] = React.useState(null);
  const [isShowingEmailMessage, setShowingEmailMessage] = React.useState(false);
  const contactsEntity = useSelector(selectContacts);
  const collaboratorsEntity = useSelector(selectFolderCollaborators);
  const restrictionsEntity = useSelector(selectFoldersRestrictions);
  const curriedDeleteCollaborator = folderId => collaboratorId => dispatch(actions.removeFolderCollaborator(collaboratorId, folderId, true));
  const shootOffEmailToast = () => {
    setTimeout(() => {
      setShowingEmailMessage(true);
      setTimeout(() => setShowingEmailMessage(false), 3000);
    }, 2000);
  };
  const isLoading = !contactsEntity.initialized || contactsEntity.loading || !collaboratorsEntity.initialized || collaboratorsEntity.loading || !restrictionsEntity.initialized || restrictionsEntity.loading;
  React.useEffect(() => {
    if (!contactsEntity.initialized) {
      dispatch(actions.getContacts());
    }
    if (!restrictionsEntity.value.byId[folder.uuid]) {
      dispatch(actions.getFolderDetails(folder.uuid));
    }
  }, []);
  const userIsOwner = folder.creator === user.userId;
  const collaboratorCanAddCollaborators = !isLoading && !((_restrictionsEntity$v = restrictionsEntity.value) === null || _restrictionsEntity$v === void 0 ? void 0 : (_restrictionsEntity$v2 = _restrictionsEntity$v.byId[folder.uuid]) === null || _restrictionsEntity$v2 === void 0 ? void 0 : _restrictionsEntity$v2.only_owner_can_add_collaborators_to_folder);
  return React.createElement(LoadingWrapper, {
    isLoading: isLoading
  }, Boolean(selectedCollaboratorId) && React.createElement(ConfirmRemoveModal, {
    isOpen: Boolean(selectedCollaboratorId),
    collaboratorId: selectedCollaboratorId,
    onConfirm: curriedDeleteCollaborator(folder.uuid),
    onClose: () => setCollaboratorId(null)
  }), React.createElement(InnerScreenGrid, {
    rowGap: RowGap.none
  }, React.createElement(Header, null, React.createElement(Typography, {
    type: "p"
  }, React.createElement(Trans, {
    id: "Share Folder"
  })), React.createElement(Typography, {
    type: "h1",
    "data-lookup": "share-dialog-folder-name-title"
  }, folder.name)), React.createElement("p", {
    "data-lookup": "share-dialog-explanation-ux-copy"
  }, React.createElement(Trans, {
    id: "Collaborators can view, add, and remove documents in this folder."
  }), React.createElement("br", null), collaboratorCanAddCollaborators && React.createElement(React.Fragment, null, React.createElement(Trans, {
    id: "They can also add additional collaborators, but not remove them."
  }), React.createElement("br", null)), React.createElement(Trans, {
    id: "Only the owner may delete the folder."
  })), React.createElement(CollaboratorsTitle, null, React.createElement(Typography, {
    type: "p"
  }, React.createElement(Trans, {
    id: "COLLABORATORS"
  })), React.createElement(EmailSentMessage, {
    isShowingMessage: isShowingEmailMessage
  }, React.createElement(Trans, {
    id: "E-mail sent"
  }))), React.createElement(AddCollaborators, {
    contacts: contactsEntity.value,
    collaborators: collaboratorsEntity.value,
    onSave: (email, folderUuid) => {
      dispatch(actions.getContacts());
      dispatch(actions.addFolderCollaborator(email, folderUuid, shootOffEmailToast));
    },
    folderUuid: folder.uuid
  }), React.createElement(CollaboratorsList, null, collaboratorsEntity.value.asList().map(collaborator => {
    const collaboratorIsNotOwner = collaborator.role !== CollaboratorRole.Owner;
    const collaboratorIsUser = collaborator.id === user.userId;
    return React.createElement(Collaborator, {
      key: collaborator.id,
      name: collaborator.name,
      email: collaborator.email,
      isDeleteable: collaboratorIsNotOwner && (userIsOwner || collaboratorIsUser),
      isUser: collaboratorIsUser,
      confirmDeleteSelf: () => setCollaboratorId(collaborator.id),
      onRemove: () => {
        dispatch(actions.getContacts());
        return dispatch(actions.removeFolderCollaborator(collaborator.id, folder.uuid, collaboratorIsUser));
      }
    });
  })), React.createElement(Organisms.Dumb.Footer, {
    onDismissClicked: onClose
  })));
};